// extracted by mini-css-extract-plugin
export default {"inputWrapper":"HtmlInputField_inputWrapper__5Tcay","html-input-label-actions":"HtmlInputField_html-input-label-actions__34SQF"};